import React from 'react';
import Panel from '../../components/ui/Panel';

const ColorUsageGuidelines: React.FC = () => {
  return (
    <div className="space-y-8">
      <h1 className="text-3xl text-osrs-gold font-bold uppercase mb-4">Color Usage Guidelines</h1>
      
      <section>
        <h2 className="text-2xl text-osrs-gold font-bold mb-4">Primary Colors</h2>
        <Panel>
          <h3 className="text-xl text-osrs-gold font-bold mb-3">Yellow & Gold</h3>
          <ul className="list-disc list-inside text-osrs-yellow space-y-2">
            <li>Use OSRS Yellow (#FFCF3F) for primary text and highlights</li>
            <li>Use OSRS Gold (#E6A519) for headings and interactive elements</li>
            <li>Maintain contrast ratios of at least 4.5:1 for text legibility</li>
            <li>Avoid using these colors for large background areas</li>
          </ul>
        </Panel>
      </section>

      <section>
        <h2 className="text-2xl text-osrs-gold font-bold mb-4">Background Colors</h2>
        <Panel>
          <h3 className="text-xl text-osrs-gold font-bold mb-3">Dark Tones</h3>
          <ul className="list-disc list-inside text-osrs-yellow space-y-2">
            <li>Use OSRS Black (#0F0F0F) for the main application background</li>
            <li>Use OSRS Dark Brown (#382D1A) for secondary backgrounds</li>
            <li>Use OSRS Panel (#46433A) for interface elements like panels and cards</li>
            <li>Maintain hierarchy through consistent background color usage</li>
          </ul>
        </Panel>
      </section>

      <section>
        <h2 className="text-2xl text-osrs-gold font-bold mb-4">Status Colors</h2>
        <Panel>
          <h3 className="text-xl text-osrs-gold font-bold mb-3">Feedback & States</h3>
          <ul className="list-disc list-inside text-osrs-yellow space-y-2">
            <li>Use OSRS Green (#00FF00) for positive feedback and success states</li>
            <li>Use OSRS Red (#FF0000) for errors, warnings, and dangerous actions</li>
            <li>Use OSRS Blue (#0088FF) for links and magical items</li>
            <li>Use status colors sparingly to maintain their impact</li>
          </ul>
        </Panel>
      </section>

      <section>
        <h2 className="text-2xl text-osrs-gold font-bold mb-4">Accessibility Guidelines</h2>
        <Panel>
          <h3 className="text-xl text-osrs-gold font-bold mb-3">Contrast & Readability</h3>
          <ul className="list-disc list-inside text-osrs-yellow space-y-2">
            <li>Ensure text meets WCAG 2.1 AA standards for contrast</li>
            <li>Use the yellow-on-black combination for primary content</li>
            <li>Avoid yellow or gold text on light backgrounds</li>
            <li>Provide sufficient contrast for interactive elements</li>
          </ul>
        </Panel>
      </section>

      <section>
        <h2 className="text-2xl text-osrs-gold font-bold mb-4">Common Patterns</h2>
        <Panel>
          <div className="space-y-4">
            <div className="p-4 bg-osrs-black">
              <p className="text-osrs-yellow">Primary text on dark background</p>
            </div>
            <div className="p-4 bg-osrs-panel border-2 border-osrs-border">
              <p className="text-osrs-gold">Panel with gold heading text</p>
            </div>
            <div className="p-4 bg-osrs-dark-brown">
              <p className="text-osrs-green">Success message example</p>
              <p className="text-osrs-red">Error message example</p>
            </div>
          </div>
        </Panel>
      </section>
    </div>
  );
};

export default ColorUsageGuidelines; 